import { useIsDesktop } from "@/common/MediaQueries";
import colors from "@/theme/colors";
import sizes from "@/theme/sizes";
import theme from "@/theme/theme";
import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Image from "next/image";
import Link from "next/link";
import { Pages } from "../../common/pages.modal";
import { trackCustomEvent } from "@/common/gtm";

const StyledHeaderWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  zIndex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  padding: sizes.header.paddingHeader,
  height: sizes.header.headerHeight,
  backgroundColor: colors.black,
  borderBottom: `1px solid ${colors.gray}`,
}));

const StyledButton = styled(Button)(() => ({
  minWidth: sizes.button.rounded.sm.width,
  height: sizes.button.rounded.sm.height,
  borderRadius: sizes.button.rounded.sm.borderRadius,
  display: "flex",
  justifyContent: "space-evenly",
  gap: 8,
  flexShrink: 0,
  whiteSpace: "nowrap", // ✅ prevent line break
}));

const LogoImageWrapper = styled(Box)(() => ({
  width: "100%",
  height: "auto",
  marginRight: 10,
  display: "flex",
  justifyContent: "flex-end",
}));

const StyledTypography = styled(Typography)`
  font-size: 18px;
  font-weight: 700;
  white-space: nowrap; /* ✅ prevent wrap */

  ${() => theme.breakpoints.down("sm")} {
    font-size: 16px;
  }
`;

const isElectricSalesCenterOpen = () => {
  const now = new Date();
  const israelNow = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Jerusalem" }),
  );

  const day = israelNow.getDay(); // Sun–Sat = 0–6
  const currentMinutes = israelNow.getHours() * 60 + israelNow.getMinutes();

  return (
    day >= 0 &&
    day <= 4 &&
    currentMinutes >= 8 * 60 + 30 &&
    currentMinutes <= 17* 60
  );
};

const Header = () => {
  const isDesktop = useIsDesktop();
  const showCallButton = !isDesktop && isElectricSalesCenterOpen();

  return (
    <StyledHeaderWrapper>
      {showCallButton && (
        <Link href="tel:098308222" passHref legacyBehavior>
          <StyledButton
            variant="contained"
            color="primary"
            onClick={() => trackCustomEvent("call_sales_header")}
          >
            <Image
              src="/icon_call.svg"
              alt="חייג למכירות"
              width={24}
              height={24}
            />
            <StyledTypography variant="button">תחזרו אליי</StyledTypography>
          </StyledButton>
        </Link>
      )}

      <LogoImageWrapper>
        <Link href={`/${Pages.onBoarding}`} aria-label="חזרה לתחילת התהליך">
          <Image
            src="/Logo-POWER.png"
            alt="לוגו סופר פאוור"
            width={
              isDesktop
                ? sizes.images.logo_sm.width
                : sizes.images.logo_sm_mobile.width
            }
            height={
              isDesktop
                ? sizes.images.logo_sm.height
                : sizes.images.logo_sm_mobile.height
            }
            style={{ verticalAlign: "middle" }}
          />
        </Link>
      </LogoImageWrapper>
    </StyledHeaderWrapper>
  );
};

export default Header;
